import { createSelector } from "reselect";

import type { ResultsReduxState } from "@app/types/results-redux-types";

import { getLegCards } from "./get-leg-cards";

export const getLegCardById = createSelector(
  [getLegCards, (_: ResultsReduxState, leg_card_id: string) => leg_card_id],
  (leg_cards, leg_card_id) => leg_cards[leg_card_id]
);
